// src/services/outOfOrderRoomsService.js
import { authedAxios } from "../utils/customHttpHeader";

const BASE = "/out-of-order-rooms";

/**
 * GET /out-of-order-rooms?hotelId={hotelId}
 */
export const listOOO = async (hotelId) => {
  const { data } = await authedAxios().get(`${BASE}?hotelId=${hotelId}`);
  return data;
};

/**
 * GET /out-of-order-rooms/{id}
 */
export const getOOO = async (id) => {
  const { data } = await authedAxios().get(`${BASE}/${id}`);
  return data;
};

/**
 * POST /out-of-order-rooms
 */
export const createOOO = async (payload) => {
  const { data } = await authedAxios().post(BASE, payload);
  return data;
};

/**
 * PUT /out-of-order-rooms/{id}
 */
export const updateOOO = async (id, payload) => {
  const { data } = await authedAxios().put(`${BASE}/${id}`, payload);
  return data;
};

/**
 * DELETE /out-of-order-rooms/{id}
 */
export const deleteOOO = async (id, payload) => {
  const { data } = await authedAxios().put(`${BASE}/${id}`, payload);
  return data;
};
